import { RootState } from '.'
import type { AnyChainsAction } from '../actions/chains'
import type { Chain } from '../types'

const initialState = {
  chains: [] as Chain[],
  error: null,
  isWorking: false,
}

export default (state: typeof initialState = initialState, action: AnyChainsAction) => {
  switch (action.type) {
    case 'CHAINS_FETCH##REQUEST':
      return {
        ...state,
        chains: [],
        error: null,
        isWorking: true,
      }
    case 'CHAINS_FETCH##FAILURE':
      return {
        ...state,
        error: action.payload.message,
        isWorking: false,
      }
    case 'CHAINS_FETCH##SUCCESS':
      return {
        ...state,
        isWorking: false,
        error: null,
        chains: action.payload,
      }
    default:
      return state
  }
}

function selectChainByID(state: RootState, id: number) {
  const chains = state.chains.chains

  return chains.find(chain => chain.id === id)
}

export { selectChainByID }
